import React from "react"

export const Heading = () => {
  return <h2 className="text-center">Leave a comment</h2>
}
